import { createApiRef } from '@backstage/core-plugin-api';

import { DxArtifact, DxOs } from '../lib/types';

export const dxSetupApiRef = createApiRef<DxSetupApi>({
  id: 'plugin.dx-setup.service',
});

export interface DxSetupApi {
  getAiCodeInsightsCurrentVersion(os?: DxOs): Promise<DxArtifact>;
}
